import React from "react"

export default function IconUserClock() {
  return (
    <span className="ico-success">
      <i className="fas fa-user-clock" title="icon-user-clock" />
    </span>
  )
}
